import { useCallback, useState } from "react";
import { Button, Modal, TextContainer } from "@shopify/polaris";

function ModalActivate({ disabled, isLoading, isDirty, ...props }) {
  const [active, setActive] = useState(false);

  const handleChange = useCallback(() => setActive(!active), [active]);

  const activator = (
    <Button
      disabled={isLoading || isDirty || disabled}
      loading={isLoading}
      onClick={handleChange}
    >
      Activate
    </Button>
  );

  return (
    <div>
      <Modal
        activator={activator}
        open={active}
        onClose={handleChange}
        title="Activate Custom Widget?"
        primaryAction={{
          content: "Activate",
          onAction: () => {
            props.handleStatusChange(1);
          },
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleChange,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>
              Are you sure you want to activate the custom widget? Once
              activated, it will replace the Loop standard widget on your store.
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    </div>
  );
}

export default ModalActivate;
